import { z } from 'zod';
import { material } from './getMaterialsWithConditions';
import { alterCode } from '../alterCodes/getAlterCodesWithConditions';

const materialAlterCode = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  boid: z.string().optional(),
  materialId: z.string(),
  alterCodeId: z.string().optional(),
  deleted: z.boolean().optional(),
  isDefault: z.boolean().optional(),
  quantityTotalizer: z.boolean().optional(),
  relationFactor: z.number().optional(),
  minSalesQuantity: z.number().optional(),
  shortCode: z.string().optional(),
  lotStart: z.string().optional(),
  lotFinsh: z.string().optional(),
  dimension1: z.number().optional(),
  dimension2: z.number().optional(),
  dimension3: z.number().optional(),
  alterCode: alterCode,
  measurementUnit: z.object({ code: z.string(), id: z.string(), name: z.string() }),
  measurementUnitId: z.string(),
  sequence: z.number().optional(),
});

const competitor = z.object({
  id: z.string(),
  code: z.string(),
});

export const getCompetitorMaterialsWithConditionsSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    isDefault: z.boolean(),
    boid: z.string().optional(),
    materialAlterCode,
    competitor,
    material,
    materialId: z.string(),
    competitorId: z.string(),
  })
);

export type GetCompetitorMaterialsWithConditionsResponse = z.infer<
  typeof getCompetitorMaterialsWithConditionsSchema
>;
